import ClickToEdit from '@zeus/core/ClickToEdit';
import { Typography } from 'antd';
import React from 'react';

interface PageTitleProps {
  editable?: boolean;
  onChange?: (value: string) => void;
  title?: string;
  validateItem?: (value: string) => boolean;
  validateText?: string;
}

function PageTitle({ editable, onChange, title, validateItem, validateText }: PageTitleProps): JSX.Element {
  return (
    <div data-test-id="page-title">
      {editable ? (
        <ClickToEdit
          fontSize="2.125rem"
          {...(onChange && { onTextChange: onChange })}
          validateItem={validateItem}
          validateText={validateText}
          value={title}
        />
      ) : (
        <Typography.Title level={4} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
      )}
    </div>
  );
}

export default PageTitle;
